import Button from '../../design-system/primitives/Button.jsx'
import StateBanner from '../StateBanner/StateBanner.jsx'
import { dinnersValueLine } from '../../utils/dinnersSection.js'
import './planner.css'

/**
 * Header for the Dinners week list: value line and one Plan with Cook pill.
 * After a plan, the pill becomes Adjust and the receipt replaces the value line.
 */
export default function PlanWeekSectionHeader({
  coverage = null,
  canPlan = false,
  busy = false,
  status = 'idle',
  error = '',
  receipt = '',
  density = 'desktop',
  onPlan = null,
  onAdjust = null,
  headingLevel = 2,
  lead = '',
}) {
  const compact = density === 'mobile'
  const TitleTag = headingLevel === 1 ? 'h1' : 'h2'
  const value = lead || dinnersValueLine({ open: coverage?.open ?? 0, canPlan })
  const done = status === 'done' && Boolean(receipt)

  return (
    <div className="pwl-head-block">
      <div className={`pwl-head${compact ? ' pwl-head--mobile' : ''}`}>
        <div className="pwl-copy">
          <TitleTag className="pwl-title">Dinners</TitleTag>
          {done ? <p className="pwl-receipt">{receipt}</p> : value ? <p className="pwl-value">{value}</p> : null}
        </div>
        {done ? (
          <Button
            id="plan-with-cook-adjust"
            variant="secondary"
            className="pwl-plan-btn"
            onClick={onAdjust}
          >
            Adjust
          </Button>
        ) : canPlan ? (
          <Button
            id="plan-with-cook-pill"
            variant="primary"
            className="pwl-plan-btn"
            onClick={onPlan}
            disabled={busy || !onPlan}
            aria-busy={busy || undefined}
          >
            {busy ? 'Planning\u2026' : (
              <>
                <span className="pwl-plan-mark" aria-hidden="true">{'\u2726'}</span>
                Plan with Cook
              </>
            )}
          </Button>
        ) : null}
      </div>
      {status === 'error' && error ? (
        <StateBanner variant="urgent" size="inline" body={error} className="pwl-error" />
      ) : null}
    </div>
  )
}
